// dependencies
import { useContext, useEffect } from 'react';
import { ThemeContext } from '../../ThemeContext';
import { Link } from 'react-router-dom';

// assets
import InStore2 from "../../assets/images/featured-ct-instore/jihan-duerme-featured-ct-instore-02.png";
import InStore3 from "../../assets/images/featured-ct-instore/jihan-duerme-featured-ct-instore-03.png";
import InStore4 from "../../assets/images/featured-ct-instore/jihan-duerme-featured-ct-instore-04.png";
import InStore5 from "../../assets/images/featured-ct-instore/jihan-duerme-featured-ct-instore-05.png";
import InStore6 from "../../assets/images/featured-ct-instore/jihan-duerme-featured-ct-instore-06.png";
import InStore7 from "../../assets/images/featured-ct-instore/jihan-duerme-featured-ct-instore-07.png";
import InStore8 from "../../assets/images/featured-ct-instore/jihan-duerme-featured-ct-instore-08.png";
import InStore9 from "../../assets/images/featured-ct-instore/jihan-duerme-featured-ct-instore-09.png";
import InStore10 from "../../assets/images/featured-ct-instore/jihan-duerme-featured-ct-instore-10.png";
import InStore11 from "../../assets/images/featured-ct-instore/jihan-duerme-featured-ct-instore-11.png";
import InStore12 from "../../assets/images/featured-ct-instore/jihan-duerme-featured-ct-instore-12.png";
import InStore13 from "../../assets/images/featured-ct-instore/jihan-duerme-featured-ct-instore-13.png";
import InStore14 from "../../assets/images/featured-ct-instore/jihan-duerme-featured-ct-instore-14.png";
import InStore15 from "../../assets/images/featured-ct-instore/jihan-duerme-featured-ct-instore-15.png";
import Icon1 from "../../assets/icons/ct-icons/search.svg";
import Icon1Dark from "../../assets/icons/ct-icons/search-dark.svg";
import Icon2 from "../../assets/icons/ct-icons/list.svg";
import Icon2Dark from "../../assets/icons/ct-icons/list-dark.svg";
import Icon3 from "../../assets/icons/ct-icons/path.svg";
import Icon3Dark from "../../assets/icons/ct-icons/path-dark.svg";
import Icon4 from "../../assets/icons/ct-icons/user.svg";

function InStore () {

        const { darkTheme } = useContext(ThemeContext);

        useEffect(() => {
            let searchImages = document.querySelectorAll('img[alt="Search icon"]');
            let listImages = document.querySelectorAll('img[alt="List icon"]');
            let pathImages = document.querySelectorAll('img[alt="Path icon"]');

            if (darkTheme) {
                searchImages.forEach(img => img.src = Icon1Dark);
                listImages.forEach(img => img.src = Icon2Dark);
                pathImages.forEach(img => img.src = Icon3Dark);
            } else {
                searchImages.forEach(img => img.src = Icon1);
                listImages.forEach(img => img.src = Icon2);
                pathImages.forEach(img => img.src = Icon3);
            }
        }, [darkTheme]);

    return (
        <main className="case-main">

            <div>
                {/* Case Study Header */}
                <header id="overview" className="in-store-hero mid-width target-section">
                    <p className="case-company">Canadian Tire</p>
                    <h1 className="mb-3">Elevating the In-Store App Experience with a Smarter, Unified Approach</h1>
                    <p className="subtitle mb-5">Canadian Tire serves millions of customers across hundreds of locations, offering everything from everyday essentials to automotive services. Customers shopping in-store follow a journey that often begins at home, planning what they need before navigating the aisles to find products in-store.</p>
                    
                    {/* Hero Image */}
                    <figure className="case-hero-image mb-5">
                        <img src={InStore2} alt="Multiple CT In-store App Screens" className="mid-img" />
                    </figure>
                    
                    {/* Project Details Desktop */}
                    <dl className="lg">
                        <dt>Duration</dt>
                        <dd>6 months (April to September 2025)</dd>
                        <dt>Status</dt>
                        <dd>Design Handoff / In Development</dd>
                        <dt>Team</dt>
                        <dd>
                            <ul>
                                <li>The project scaled from a single Concept Designer to a cross-functional team of <strong>2 UX Designers, 2 UX Researchers, and 1 UI Designer</strong>, collaborating closely with Business and Engineering partners.</li>
                                <li><strong>I led the design of the Wishlist and ESL experiences</strong>, owning the end-to-end flow from concept exploration through interaction modeling and handoff.</li>
                            </ul>
                        </dd>
                        <dt>My Roles and Responsibilities</dt>
                        <dd>
                            <ul>
                                <li>Defined user flows and interaction models</li>
                                <li>Analyzed research insights and usage data</li>
                                <li>Iterated designs within technical and business constraints</li>
                                <li>Led presentations of select design concepts to cross-functional teams</li>
                                <li>Documented decisions and aligned app, kiosk, and in-store experiences</li>
                            </ul>
                        </dd>
                    </dl>

                    {/* Project Details Mobile */}
                    <dl className="sm">
                        <dt>Duration</dt>
                        <dd>6 months (April to September 2025)</dd>
                        <dt>Status</dt>
                        <dd>Design Handoff / In Development</dd>
                        <dt>Team</dt>
                        <dd>
                            <ul>
                                <li>The project scaled from a single Concept Designer to a cross-functional team of <strong>2 UX Designers, 2 UX Researchers, and 1 UI Designer</strong>, collaborating closely with Business and Engineering partners.</li>
                                <li><strong>I led the design of the Wishlist and ESL experiences</strong>, owning the end-to-end flow from concept exploration through interaction modeling and handoff.</li>
                            </ul>
                        </dd>
                        <dt>My Roles and Responsibilities</dt>
                        <dd>
                            <ul>
                                <li>Defined user flows and interaction models</li>
                                <li>Analyzed research insights and usage data</li>
                                <li>Iterated designs within technical and business constraints</li>
                                <li>Led presentations of select design concepts to cross-functional teams</li>
                                <li>Documented decisions and aligned app, kiosk, and in-store experiences</li>
                            </ul>
                        </dd>
                    </dl>
                </header>
                
                {/* Main Content */}
                <article>

                    {/* Goal */}
                    <section id="goal" className="target-section mid-width">
                        <h2>Project Goal</h2>
                        <p>Create a dedicated in-store experience for customers to seamlessly transition from at-home planning to in-store shopping by making key in-store features and tools easy to discover and use, increasing app engagement and loyalty program usage during high-intent shopping moments.</p>
                    </section>

                    {/* Problem */}
                    <section id="problem" className="target-section mid-width">
                        <h2>Problem</h2>
                        <p className="mb-4">Customers struggled to incorporate the app into their in-store shopping experience. Helpful tools were either hard to discover or difficult to access at the exact moment they were needed, leading to friction, missed engagement, and reduced conversion.</p>
                        <div>
                            <figure className="case-med-img mb-4">
                                <img src={InStore3} alt="Screens on Production prior to redesign" className="mid-img mb-2" />
                                <figcaption>Features that would be helpful for in-store customers were buried within different parts of the app.</figcaption>
                            </figure>
                            <div className="case-small-img mid-img">
                                <figure>
                                    <img src={InStore4} alt="ESL Activation in-store" className="mid-img mb-2" />
                                    <figcaption>ESL activation was only accessible through the product details page prior to this project</figcaption>
                                </figure>
                                <figure>
                                    <img src={InStore5} alt="Order Pickup in-store" className="mid-img mb-2" />
                                    <figcaption>The locker pickup QR code is buried in the app, taking too many clicks to find</figcaption>
                                </figure>
                            </div>
                        </div>
                    </section>

                    {/* Insights and Opportunities */}
                    <section id="insights" className="target-section">
                        <div className="mid-width mb-4">
                            <h2>Insights and Opportunities</h2>
                            <p>Based on user testing of the production experience prior to this project, I helped identify several high-impact opportunities to better support customers before and during their in-store visit. These insights were informed by usability testing, usage data and feedback from business partners, which helped prioritize the areas with the greatest potential impact for this MVP:</p>
                        </div>
                        <div className="case-cards">

                            {/* Opportunity 1 */}
                            <article>
                                <img src={darkTheme ? Icon1Dark : Icon1} alt="Search icon" />
                                <h3>Improve discoverability of in-store tools at critical moments</h3>
                                <p><span>Why? </span>Many test participants were unaware of the existence of our in-store tools or how to use them. However, once customers learn about these tools, they become the most-used actions, validating their value when made discoverable.</p>
                            </article>

                            {/* Opportunity 2 */}
                            <article>
                                <img src={darkTheme ? Icon2Dark : Icon2} alt="List icon" />
                                <h3>Support intentional shopping list planning from home to store</h3>
                                <p><span>Why? </span>Although less than 50% of our monthly users shop in-store, those who do have sessions that are 2.5x longer than online sessions, showing highly intentional, goal-driven behavior.</p>
                            </article>

                            {/* Opportunity 3 */}
                            <article>
                                <img src={darkTheme ? Icon3Dark : Icon3} alt="Path icon" />
                                <h3>Protect and reinforce purchase intent during moments of friction</h3>
                                <p><span>Why? </span>Customers typically research products before visiting our stores and arrive with strong purchase intent. When items are out of stock or difficult to locate, that intent quickly erodes, leading to abandonment and decreased conversion.</p>
                            </article>

                        </div>
                    </section>

                    {/* Solution Discovery */}
                    <section id="solution" className="target-section mid-width">
                        <h2>Solution Discovery</h2>
                        <p>After assessing the potential impact and effort required for each feature, we prioritized the following in-store capabilities from different areas of the app, optimized them, and combined them into a unified in-store experience for upcoming sprints:</p>
                        
                        {/* List Desktop */}
                        <dl className="lg">
                            <dt>Discover & Access In-Store Mode</dt>
                            <dd>Onboarding and clear entry point with location enablement</dd>
                            <dt>Wishlist as Shopping List</dt>
                            <dd>Real-time price, availability, and aisle location for saved items</dd>
                            <dt>ESL Activation</dt>
                            <dd>Trigger shelf labels to flash and locate products instantly</dd>
                            <dt>Barcode Scanner</dt>
                            <dd>Scan products for details, including price, availability, and aisle location</dd>
                            <dt>Locker Pickup</dt>
                            <dd>Order status, instructions, and scan codes</dd>
                            <dt>Weekly Flyer</dt>
                            <dd>View in-store promotions with quick access to product details</dd>
                            <dt>My Garage</dt>
                            <dd>Save your vehicle information to find products that fit</dd>
                            <dt>Store Details</dt>
                            <dd>Hours, services, and department locations</dd>
                        </dl>

                        {/* List Mobile */}
                        <dl className="sm">
                            <dt>Discover & Access In-Store Mode</dt>
                            <dd>Onboarding and clear entry point with location enablement</dd>
                            <dt>Wishlist as Shopping List</dt>
                            <dd>Real-time price, availability, and aisle location for saved items</dd>
                            <dt>ESL Activation</dt>
                            <dd>Trigger shelf labels to flash and locate products instantly</dd>
                            <dt>Barcode Scanner</dt>
                            <dd>Scan products for details, including price, availability, and aisle location</dd>
                            <dt>Locker Pickup</dt>
                            <dd>Order status, instructions, and scan codes</dd>
                            <dt>Weekly Flyer</dt>
                            <dd>View in-store promotions with quick access to product details</dd>
                            <dt>My Garage</dt>
                            <dd>Save your vehicle information to find products that fit</dd>
                            <dt>Store Details</dt>
                            <dd>Hours, services, and department locations</dd>
                        </dl>
                    </section>

                    {/* Deep Dive */}
                    <section id="deep-dive" className="target-section">
                        <h2 className="mid-width">Deep Dive: Wishlist as Shopping List and ESL Activation</h2>
                        <p className="mid-width mb-4">Below is a closer look at the Wishlist and ESL experiences, two areas I led, and the key considerations that informed design decisions.</p>
                        <div className="case-small-img">
                            <figure>
                                <img src={InStore6} alt="In-store Wishlist Carousel" className="mid-img mb-2" />
                            </figure>
                            <figure>
                                <img src={InStore7} alt="In-store ESL Activated" className="mid-img mb-2" />
                            </figure>
                        </div>
                    </section>

                    {/* Customer Needs */}
                    <section id="needs" className="target-section">
                        <div className="mid-width mb-4">
                            <h2>What do our customers hope to shop in-store successfully?</h2>
                            <p>To better understand customer behavior, I incorporated customer feedback gathered through a Medallia survey conducted by our UX researcher in May and June 2025. The research explored how customers plan shopping trips and locate items within the existing app, which helped identify opportunities for improvement.</p>
                            <p>Several recurring themes emerged:</p>
                        </div>
                        <div className="case-list mid-width">

                            {/* Customer Needs 1 */}
                            <div className="mb-4">
                                <div className="case-feedback">
                                    <div className="case-user mb-2">
                                        <img src={Icon4} alt="User 1 icon" />
                                        <p>User Testing Participant</p>
                                    </div>
                                    <blockquote>
                                        <p>“I don't actually buy online, but I use the app cart to create a shopping list”</p>
                                    </blockquote>
                                </div>
                                <div className="case-need">
                                    <h3>Planning Behavior</h3>
                                    <p className="mb-0">While many in-store customers used the app to plan their store visit, several were confused about the purpose of the Wishlist, leading them to rely on shopping list workarounds such as the Cart or external notes after browsing items they needed.</p>
                                </div>
                            </div>


                            {/* Customer Needs 2 */}
                            <div className="mb-4">
                                <div className="case-feedback">
                                    <div className="case-user mb-2">
                                        <img src={Icon4} alt="User 2 icon" />
                                        <p>User Testing Participant</p>
                                    </div>
                                    <blockquote>
                                        <p>“It's helpful to know the [product] availability and price ahead of time”</p>
                                    </blockquote>
                                </div>
                                <div className="case-need">
                                    <h3>Information Needs</h3>
                                    <p className="mb-0">Customers wanted reassurance before and during their visit that an item was available, reasonably priced, and worth the trip. This reinforced the need to surface price, stock information and location together at first glance.</p>
                                </div>
                            </div>

                            {/* Customer Needs 3 */}
                            <div>
                                <div className="case-feedback">
                                    <div className="case-user mb-2">
                                        <img src={Icon4} alt="User 3 icon" />
                                        <p>User Testing Participant</p>
                                    </div>
                                    <blockquote>
                                        <p>“I love the ability to check which aisle a product is in while in the store. Also love the tag for the specific item that lights up.”</p>
                                    </blockquote>
                                </div>
                                <div className="case-need">
                                    <h3>Navigation & Wayfinding</h3>
                                    <p className="mb-0">While some customers valued aisle-level guidance and the ESL feature, others were unaware the feature even existed or did not have location services enabled. This highlighted a discoverability gap, reinforcing the need for clearer entry points and education.</p>
                                </div>
                            </div>

                        </div>
                    </section>

                    {/* MVP Scope */}
                    <section id="scope" className="target-section mid-width">
                        <div className='mb-4'>
                            <h2>MVP Scope</h2>
                            <p>For this first release, the Wishlist and ESL experiences needed to:</p>
                            <ul>
                                <li>Surface saved items in a format optimized for in-store use</li>
                                <li>Show real-time price, availability and aisle location at a glance</li>
                                <li>Allow ESL activation directly from the Wishlist</li>
                                <li>Maintain consistency within existing product patterns to reduce learning effort</li>
                                <li>Adhere to Baymard guidelines with minimal tradeoffs</li>
                            </ul>
                        </div>
                        <figure className="case-med-img mb-4">
                            <img src={InStore8} alt="In-store User Flow" className="mid-img mb-2" />
                            <figcaption>End-to-end Wishlist flow showing entry into In-Store Mode and ESL activation (Post-iteration)</figcaption>
                        </figure>
                        <figure className="case-med-img mb-4">
                            <img src={InStore9} alt="Initial In-store Prototypes" className="mid-img mb-2" />
                            <figcaption>Initial wireframes exploring core paths and edge cases derived from the user flow</figcaption>
                        </figure>
                    </section>

                    {/* Iterations */}
                    <section id="iterations" className="target-section mid-width">
                        <div className="mb-4">
                            <h2>Iterations</h2>
                            <p>Through several rounds of user testing, engineering feasibility discussions, and alignment with the business teams, I closely collaborated with the UI designer to refine the visual design of each component.</p>
                        </div>
                        <div className="case-list">

                            {/* Iteration 1 */}
                            <div className="iterations mb-4">
                                <img src={InStore10} alt="Limited carousel items" className="mid-img" />
                                <div>
                                    <h3 className="mb-2">Appropriate Wishlist Size</h3>
                                    <ul>
                                        <li>Limited the Wishlist carousel on the 'My Store' screen to a maximum of 10 items</li>
                                        <li>Introduced a dedicated full Wishlist page using a compact list layout</li>
                                    </ul>
                                    <p className="mb-0"><span>Why? </span>Data shows that fewer than 10% of users had more than 10 items saved in their Wishlist. By changing the design, the in-store view is kept focused and scannable while still supporting users who have longer lists.</p>
                                </div>
                            </div>

                            {/* Iteration 2 */}
                            <div className="iterations mb-4">
                                <img src={InStore11} alt="Information hierarchy" className="mid-img" />
                                <div>
                                    <h3 className="mb-2">Essential Information for Real-Time Use</h3>
                                    <ul>
                                        <li>Removed Reviews from Wishlist product cards</li>
                                        <li>Moved ESL instructions from inline tooltips to first-time In-Store Mode onboarding</li>
                                    </ul>
                                    <p className="mb-0"><span>Why? </span>We learned that by the time customers are in-store, they've typically already researched items that they've saved. Testing showed users understood ESL activation after one explanation and did not need repeated guidance.</p>
                                </div>
                            </div>

                            {/* Iteration 3 */}
                            <div className="iterations mb-4">
                                <img src={InStore12} alt="Dead-ends to discovery" className="mid-img" />
                                <div>
                                    <h3 className="mb-2">Turned Dead-Ends into Discovery</h3>
                                    <ul>
                                        <li>Replaced empty Wishlist states with 'Most Recently Viewed' items</li>
                                        <li>Hid the section entirely when no relevant items existed</li>
                                    </ul>
                                    <p className="mb-0"><span>Why? </span>This approach provides a more personalized experience by showing users products they've recently browsed, keeping them engaged even when their Wishlist is empty.</p>
                                </div>
                            </div>

                            {/* Iteration 4 */}
                            <div className="iterations mb-4">
                                <img src={InStore13} alt="Consistency throughout the app" className="mid-img" />
                                <div>
                                    <h3 className="mb-2">Reinforcing Consistency at Scale</h3>
                                    <ul>
                                        <li>Kept the CTA label “Find Product” for consistency across the app</li>
                                        <li>Grouped price, availability, and aisle location near the CTA</li>
                                    </ul>
                                    <p className="mb-0"><span>Why? </span>Consistent language and proximity of information reduced hesitation in-store, surfacing the most critical information when it was needed most.</p>
                                </div>
                            </div>

                        </div>
                    </section>

                    {/* Other Screens */}
                    <section className="case-small-img">
                        <figure>
                            <img src={InStore14} alt="CT In-store App Screens" className="mid-img mb-2" />
                            <figcaption>Happy Path - Customers find the item immediately and activates the ESL button</figcaption>
                        </figure>
                        <figure>
                            <img src={InStore15} alt="CT In-store App Screens" className="mid-img mb-2" />
                            <figcaption>Some of the final alternative and edge case screens</figcaption>
                        </figure>
                    </section>

                    {/* Early Results and Projected Impact */}
                    <section id="outcomes" className="target-section mid-width">
                        <h2>Early Results & Projected Impact</h2>
                        <p>During moderated prototype testing, we observed behavioral improvements compared to prior production testing:</p>
                        <ul>
                            <li>ESL activation became a repeat behavior once learned</li>
                            <li>In-Store Mode entry was consistently discovered within the first task attempt</li>
                            <li>Participants completed the Wishlist-to-aisle flow with fewer hesitations and reduced backtracking</li>
                        </ul>
                        <p>These early results suggest improved clarity, reduced cognitive load, and stronger reinforcement of purchase intent during in-store visits.</p>
                    </section>
                </article>
            </div>
            
            <div className='case-back'>
                <Link to="/" className="button">
                Back to Home
                </Link>
            </div>

        </main>
    );
};

export default InStore;